export default {
      id: "oc-close-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "sprite.svg#oc-close",
      toString: function () {
        return this.url;
      }
    }